import { compareStringsCaseDiacriticInsensitive } from "@/helpers/stringUtility";

export const duplicateMilestoneTemplateValueExists = (
  idOfMilestoneTemplateBeingEdited,
  existingMilestoneTemplates,
  property,
  value
) => {
  const idsAreNotEqual = (existingMilestoneTemplateId) =>
    !idOfMilestoneTemplateBeingEdited ||
    existingMilestoneTemplateId !== idOfMilestoneTemplateBeingEdited;

  return existingMilestoneTemplates?.some(
    (existingMilestoneTemplate) =>
      compareStringsCaseDiacriticInsensitive(
        existingMilestoneTemplate[property],
        value
      ) && idsAreNotEqual(existingMilestoneTemplate.id)
  );
};
